export const emptyListProps = {
  title: 'Este cliente não possui produtos',
  description: 'Envie um nova ordem de investimentos para seus clientes.',
};
